import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../config/images";
import WashingTab from "./WashingModal";
import StaticLeaching from "./StaticLeaching";
import TumbleDrying from "./TumbleDrying";
import ProngOven from "./ProngOven";
import Cutting from "./Cutting";
import AcConditioning from "./AcConditioning";
import HancoWashing from "./HancoMachine";
import ExtraAcConditioning from "./ExtraAcCondtioner";
import dayjs from "dayjs";
import { Box, TablePagination } from "@mui/material";
import LeachingReport from "./Leaching";
import TunnelOven from "./TunnelOven";
import Washing2Tab from "./Washing2";
import {
  getProngOven1StationDetails,
  getProngOven2StationDetails,
  getProngOven3StationDetails,
  getProngOven4StationDetails,
  getTumbleDrying1StationDetails,
  getTumbleDrying2StationDetails,
} from "../ProductionLine/services";
import { toast } from "react-toastify";
import AutoClave from "./AutoClave";
import Stripping from "./Stripping";
import Chlorination from "./Chlorination";
import { useNavigate } from "react-router-dom";

const Washing = ({
  value,
  data,
  page,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  count,
  searchText,
  setSearchText,
  handleSearchData,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isWashing2Open, setWashing2Open] = useState(false);
  const [isStaticLeaching, setStaticLeaching] = useState(false);
  const [isTumbleDrying, setTumbleDrying] = useState(false);
  const [isTumbleDrying2, setTumbleDrying2] = useState(false);
  const [isProngOven, setProngOven] = useState(false);
  const [isProngOven2, setProngOven2] = useState(false);
  const [isProngOven3, setProngOven3] = useState(false);
  const [isProngOven4, setProngOven4] = useState(false);
  const [isAutoClave, setAutoClave] = useState(false);
  const [strippingPopup, setStrippingPopup] = useState(false);
  const [isCutting, setCutting] = useState(false);
  const [isAcConditioner, setAcConditioner] = useState(false);
  const [isHancoWashing, setHancoWashing] = useState(false);
  const [isExtraAcConditioner, setExtraAcConditioner] = useState(false);
  const [leachingPopup, setLeachingPopup] = React.useState(false);
  const [batchId, setBatchId] = useState(null);
  const [tunnelOvenPopup, setTunnelOvenPopup] = useState(false);
  const [prongOvenData, setProngOvenData] = useState([]);
  const [prongOvenData2, setProngOvenData2] = useState([]);
  const [prongOvenData3, setProngOvenData3] = useState([]);
  const [prongOvenData4, setProngOvenData4] = useState([]);
  const [chlorinationPopup, setchlorinationPopup] = useState(false);
  const [ultraSonicData,setUltraSonicData] = useState([]);


  useEffect(() => {
    if (batchId) {
      if (value == 10) {
        handleGetProngOven();
      } else if (value == 15) {
        handleGetProngOven2();
      } else if (value == 19) {
        handleGetProngOven3();
      } else if (value == 22) {
        handleGetProngOven4();
      }
    }
  }, [batchId]);

  const handleGetProngOven = async () => {
    try {
      const resp = await getProngOven1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProngOvenData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProngOvenData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven2 = async () => {
    try {
      const resp = await getProngOven2StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProngOvenData2(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProngOvenData2([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven3 = async () => {
    try {
      const resp = await getProngOven3StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProngOvenData3(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProngOvenData3([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven4 = async () => {
    try {
      const resp = await getProngOven4StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProngOvenData4(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProngOvenData4([]);
      console.log("handlesubmit", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const navigate = useNavigate();

  const handleViewIcon = (batch) => {
    setBatchId(batch);
    if (value == 1) {
      console.log("batchdklfl;sdsdfsd");
      navigate(`/report-visual-inspection/${batch}`);
    }
    if (value == 2) {
      setLeachingPopup(true);
    }
    if (value == 3) {
      setTunnelOvenPopup(true);
    }
    if (value == 8) {
      setIsModalOpen(true);
    } else if (value == 7) {
      setStaticLeaching(true);
    } else if (value == 9) {
      setTumbleDrying(true);
    } else if (value == 10) {
      setProngOven(true);
    } else if (value == 15) {
      setProngOven2(true);
    } else if (value == 19) {
      setProngOven3(true);
    } else if (value == 22) {
      setProngOven4(true);
    } else if (value == 12) {
      setCutting(true);
    } else if (value == 13) {
      setWashing2Open(true);
    } else if (value == 16) {
      setAcConditioner(true);
    } else if (value == 17) {
      setHancoWashing(true);
    } else if (value == 9) {
      setTumbleDrying(true);
    } else if (value == 14) {
      setTumbleDrying2(true);
    } else if (value == 11) {
      setAutoClave(true);
    } else if (value == 20) {
      setExtraAcConditioner(true);
    } else if (value == 18) {
      setchlorinationPopup(true);
    } else if (value == 4) {
      setStrippingPopup(true);
    }
  };


  console.log("dcguihjd", value);
  const [tumbleDryingData, setTumbleDryingData] = useState([]);
  const [tumbleDrying2Data, setTumbleDrying2Data] = useState([]);

  useEffect(() => {
    if (value == 9) {
      handleGetTumbleDrying1();
    } else if (value == 14) {
      handleGetTumbleDrying2();
    }
  }, [batchId]);

  const handleGetTumbleDrying1 = async () => {
    try {
      const resp = await getTumbleDrying1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDryingData(resp.data.payload);
      }
    } catch (error) {
      setTumbleDryingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetTumbleDrying2 = async () => {
    try {
      const resp = await getTumbleDrying2StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDrying2Data(resp.data.payload);
      }
    } catch (error) {
      setTumbleDrying2Data([]);
      console.log("handlesubmit", error);
    }
  };

  return (
    <>
      <div></div>
      {/* {props.qrPrinting ? ( */}
      <>
        <div>
          <div className="table-responsive">
            <Table
              aria-label="Dipping parameter"
              className="dipping-parameter-table  washing-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Batch No</TableCell>
                  <TableCell>Shift</TableCell>
                  <TableCell>Start Date Time</TableCell>
                  <TableCell>End Date Time</TableCell>
                  <TableCell>LOT No</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Thickness</TableCell>
                  <TableCell>Good Quantity</TableCell>
                  {value == 1 && (
                    <>
                      <TableCell>Hold</TableCell>
                      <TableCell>Reject</TableCell>
                    </>
                  )}

                  <TableCell>Status</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Date"
                      name="date"
                      value={searchText?.date}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="B.No"
                      name="bNo"
                      value={searchText.bNo}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Shift"
                      name="shift"
                      value={searchText.shift}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Start Date Time"
                      name="startTime"
                      value={searchText.startTime}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="End Date Time"
                      name="endTime"
                      value={searchText.endTime}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Lot No"
                      name="lotNo"
                      value={searchText.lotNo}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Class"
                      name="class"
                      value={searchText.class}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Size"
                      name="size"
                      value={searchText.size}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Thickness"
                      name="thickness"
                      value={searchText.thickness}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Good"
                      name="good"
                      value={searchText.good}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  {value == 1 && (
                    <>
                      <TableCell className="search-table-row">
                        <SearchIcon className="search-icon" />
                        <input
                          type="search"
                          placeholder="Reject"
                          name="reject"
                          value={searchText.reject}
                          onChange={handleSearchData}
                        />
                      </TableCell>

                      <TableCell className="search-table-row">
                        <SearchIcon className="search-icon" />
                        <input
                          type="search"
                          placeholder="Hold"
                          name="hold"
                          value={searchText.hold}
                          onChange={handleSearchData}
                        />
                      </TableCell>
                    </>
                  )}

                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Status"
                      // name="Thickness"
                      // value={searchText.}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((e) => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>
                          {e.created_at
                            ? dayjs(e.created_at).format("YYYY-MM-DD")
                            : ""}
                        </TableCell>
                        <TableCell>{e?.batch_type}</TableCell>
                        <TableCell>{e?.shift_name}</TableCell>
                        {value == 2 ? (
                          <TableCell>
                            {e.hot_leach_cycle_start_time
                              ? dayjs(e.hot_leach_cycle_start_time).format(
                                  "YYYY-MM-DD  HH:mm"
                                )
                              : ""}
                          </TableCell>
                        ) : (
                          <TableCell>
                            {e.cycle_start_time
                              ? dayjs(e.cycle_start_time).format(
                                  "YYYY-MM-DD  HH:mm"
                                )
                              : ""}
                          </TableCell>
                        )}

                        {value == 2 ? (
                          <TableCell>
                            {e.cold_leach_cycle_end_time
                              ? dayjs(e.cold_leach_cycle_end_time).format(
                                  "YYYY-MM-DD  HH:mm"
                                )
                              : ""}
                          </TableCell>
                        ) : (
                          <TableCell>
                            {e.cycle_end_time
                              ? dayjs(e.cycle_end_time).format(
                                  "YYYY-MM-DD  HH:mm"
                                )
                              : ""}
                          </TableCell>
                        )}

                        <TableCell>{e?.lot_no}</TableCell>
                        <TableCell>{e?.class_name}</TableCell>
                        <TableCell>{e?.size_name}</TableCell>
                        <TableCell>{e?.thickness}</TableCell>
                        <TableCell>
                          <Box
                            className={
                              e.good !== null && e.good !== undefined
                                ? "good-status"
                                : ""
                            }
                          >
                            {e.good !== null && e.good !== undefined
                              ? e.good
                              : ""}
                          </Box>
                        </TableCell>
                        {value == 1 && (
                          <>
                            <TableCell>
                              <Box
                                className={
                                  e.reject !== null && e.reject !== undefined
                                    ? "reject-status"
                                    : ""
                                }
                              >
                                {e.reject !== null && e.reject !== undefined
                                  ? e.reject
                                  : ""}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                className={
                                  e.hold !== null && e.hold !== undefined
                                    ? "hold-status"
                                    : ""
                                }
                              >
                                {e.hold !== null && e.hold !== undefined
                                  ? e.hold
                                  : ""}
                              </Box>
                            </TableCell>
                          </>
                        )}

                        <TableCell>
                          <img
                            src={images.viewIcon}
                            alt=""
                            onClick={() => handleViewIcon(e.batch)}
                            style={{ cursor: "pointer" }}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              className="table-pagination"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={count ? count : ""}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
        {isModalOpen && (
          <WashingTab setIsModalOpen={setIsModalOpen} batchId={batchId} />
        )}
        {isWashing2Open && (
          <Washing2Tab setIsModalOpen={setWashing2Open} batchId={batchId} />
        )}
        {isStaticLeaching && (
          <StaticLeaching
            setStaticLeaching={setStaticLeaching}
            batchId={batchId}
          />
        )}
        {isTumbleDrying && (
          <TumbleDrying
            data={tumbleDryingData}
            setTumbleData={setTumbleDrying}
            batchId={batchId}
          />
        )}
        {isTumbleDrying2 && (
          <TumbleDrying
            data={tumbleDrying2Data}
            setTumbleData={setTumbleDrying2}
            batchId={batchId}
          />
        )}
        {isProngOven && (
          <ProngOven data={prongOvenData} setProngOven={setProngOven} />
        )}
        {isProngOven2 && (
          <ProngOven data={prongOvenData2} setProngOven={setProngOven2} />
        )}
        {isProngOven3 && (
          <ProngOven data={prongOvenData3} setProngOven={setProngOven3} />
        )}
        {isProngOven4 && (
          <ProngOven data={prongOvenData4} setProngOven={setProngOven4} />
        )}
        {isAutoClave && (
          <AutoClave setAutoClave={setAutoClave} batchId={batchId} />
        )}
        {strippingPopup && (
          <Stripping setStrippingPopup={setStrippingPopup} batchId={batchId} />
        )}
        {leachingPopup && (
          <LeachingReport
            setLeachingPopup={setLeachingPopup}
            batchId={batchId}
          />
        )}
        {tunnelOvenPopup && (
          <TunnelOven
            setTunnelOvenPopup={setTunnelOvenPopup}
            batchId={batchId}
          />
        )}
        {isCutting && <Cutting setCutting={setCutting} batchId={batchId} />}
        {isAcConditioner && (
          <AcConditioning
            setAcConditioner={setAcConditioner}
            batchId={batchId}
          />
        )}
        {isHancoWashing && (
          <HancoWashing setHancoWashing={setHancoWashing} batchId={batchId} />
        )}
        {isExtraAcConditioner && (
          <ExtraAcConditioning
            setExtraAcConditioner={setExtraAcConditioner}
            batchId={batchId}
          />
        )}

        {chlorinationPopup && (
          <Chlorination
            setchlorinationPopup={setchlorinationPopup}
            batchId={batchId}
          />
        )}

        {/* {isTunnelOven && <T onClose={() => setHancoWashing(false)} />} */}

        <div className="d-flex justify-content-end aborted">
          <p style={{ margin: 0, marginBottom: 0 }}>
            Powered by <b>Hikar&#174;Technomation</b> Private Limited &#169; All
            Rights Reserved
          </p>
        </div>
      </>
    </>
  );
};

export default Washing;